import React, { useCallback, useMemo, useState } from 'react';
import i18next from 'i18next';
import { useTranslation } from 'react-i18next';

type Path = { name: string; path?: { name: string; linkTo?: string }[] };

interface BreadcrumbContextModel {
  location: Path;
  setLocation: (path: Path) => void;
}

const BreadcrumbContext = React.createContext<BreadcrumbContextModel>({
  location: { name: i18next.t('pages.dashboard.title'), path: [] },
  setLocation: () => null,
});

function BreadcrumbProvider({ children }: React.PropsWithChildren<unknown>) {
  const { t } = useTranslation();
  const [location, setLocation] = useState<Path>({
    name: t('pages.dashboard.title'),
    path: [],
  });

  const updateLocation = useCallback((value: Path) => {
    setLocation(value);
    document.title = value.name;
  }, []);

  const state = useMemo(
    () => ({
      location,
      setLocation: updateLocation,
    }),
    [location, updateLocation],
  );

  return <BreadcrumbContext value={state}>{children}</BreadcrumbContext>;
}

export { BreadcrumbContext, BreadcrumbProvider };
